import React, {useEffect, useState} from 'react'
import styles from './skillBuilding.module.scss'

import Auth from 'Class/Auth'
import {TimeSince} from 'Functions'

import IconItem from 'Components/UI/IconItem'
import Item from 'Components/UI/Item'
import Preview from 'Components/Layout/Preview'
import User from 'Components/UI/User'

const ListItem = ({
    className = '',
    community = 0,
    data,
    image,
    name,
    onDelete: deleteSelf,
    onDeleted,
    onEdit,
    onSelect,
    selected,
    updated,
    user
}) =>
{
    const [userName, setUserName] = useState(null)
    const canEdit = Auth.UserId === parseInt(user, 10) || Auth.IsAdmin() || Auth.CanManage('community', community)

    const onDelete = async (data) =>
    {
        if (!deleteSelf)
        {
            return
        }
        const deleted = await deleteSelf(data)
        deleted && onDeleted && onDeleted(data)
    }

    const onLoadUser = (_, data) =>
    {
        setUserName(data.name)
    }

    return (
        <Item
            className={[styles.listItem, selected && styles.selected, className].filter(c => !!c).join(' ')}
            onClick={() => onSelect && onSelect(data)}
        >
            <Preview
                className={styles.listItemImage}
                content='activity'
                image={image}
            />
            <div className={styles.listItemContent}>
                <div className={styles.listItemName}>{ name || 'Unnamed specialization'}</div>
                <div className={styles.listItemTray}>
                    <IconItem
                        disabled={!canEdit}
                        feather='Edit'
                        label="Edit"
                        onClick={() => onEdit && onEdit(data)}
                        title="Edit this activity"
                    />
                    <IconItem
                        disabled={!canEdit}
                        feather='Trash'
                        label='Delete'
                        onClick={() => onDelete && onDelete(data)}
                        title='Permanently remove this activity'
                    />
                    <div className={styles.listItemInfo}>
                        <User
                            className={styles.listItemUserAvatar}
                            onLoad={onLoadUser}
                            size={20}
                            user={user}
                        />
                        <div className={styles.listItemUserName}>
                            {userName || 'Loading...'}
                        </div>
                    </div>
                    <div className={styles.listItemInfo}>
                        Updated {TimeSince(updated, true)}
                    </div>
                </div>
            </div>
        </Item>
    )
}

export default ListItem